import { render } from "./Ubl.vue?vue&type=template&id=abb7a25a&scoped=true"
import script from "./Ubl.vue?vue&type=script&lang=js"
export * from "./Ubl.vue?vue&type=script&lang=js"

import "./Ubl.vue?vue&type=style&index=0&id=abb7a25a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-abb7a25a"]])

export default __exports__